import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, apiError } from '../../lib/api';

export default function AdminBusinesses() {
  const [tab, setTab] = useState('pending');
  const [businesses, setBusinesses] = useState([]);
  const [err, setErr] = useState('');

  const load = async () => {
    try {
      const url = tab === 'pending' ? '/admin/businesses/pending' : '/businesses';
      const { data } = await api.get(url);
      setBusinesses(data.businesses || []);
    } catch (e) { setErr(apiError(e)); }
  };
  useEffect(() => { load(); }, [tab]); // eslint-disable-line

  const setStatus = async (b, status) => {
    try { await api.put(`/admin/businesses/${b.id}/status`, { status }); await load(); }
    catch (e) { alert(apiError(e)); }
  };

  const togglePremium = async (b) => {
    try { await api.put(`/admin/businesses/${b.id}`, { is_premium: b.is_premium ? 0 : 1 }); await load(); }
    catch (e) { alert(apiError(e)); }
  };

  return (
    <div data-testid="admin-businesses">
      <h2 className="mb-3">Businesses</h2>
      <div className="d-flex gap-2 mb-3">
        <button className={tab==='pending'?'btn-ap':'btn-ap-outline'} onClick={()=>setTab('pending')} data-testid="tab-pending">Pending approvals</button>
        <button className={tab==='approved'?'btn-ap':'btn-ap-outline'} onClick={()=>setTab('approved')} data-testid="tab-approved">All approved</button>
      </div>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead>
            <tr><th>ID</th><th>Name</th><th>Category</th><th>City</th><th>Status</th><th>Premium</th><th style={{width:280}}>Actions</th></tr>
          </thead>
          <tbody>
            {businesses.map(b => (
              <tr key={b.id} data-testid={`biz-row-${b.id}`}>
                <td>{b.id}</td>
                <td><Link to={`/business/${b.slug}`}>{b.name}</Link></td>
                <td>{b.category_name}</td>
                <td>{b.city_name}</td>
                <td><span className={'pill pill-' + b.status}>{b.status}</span></td>
                <td>{b.is_premium ? 'Yes' : 'No'}</td>
                <td>
                  {b.status !== 'approved' && <button className="btn-ap-outline btn-sm me-2" onClick={()=>setStatus(b,'approved')} data-testid={`approve-${b.id}`}>Approve</button>}
                  {b.status !== 'rejected' && <button className="btn-ap-outline btn-sm me-2" onClick={()=>setStatus(b,'rejected')} data-testid={`reject-${b.id}`}>Reject</button>}
                  <button className="btn-ap-outline btn-sm" onClick={()=>togglePremium(b)} data-testid={`premium-${b.id}`}>{b.is_premium ? 'Un-Premium' : 'Make Premium'}</button>
                </td>
              </tr>
            ))}
            {businesses.length === 0 && <tr><td colSpan="7" className="text-center py-4 text-muted-2">No businesses.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
